import React, { createContext, useMemo, useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getInlineConfigFromQueue } from '../helpers/WidgetConfigHelper';
import * as propertiesActions from 'State/actions/hotels';
import { setConfig } from 'Actions/widgetPool';
import { scrollToTop } from 'Shared/utils/UtilsHelper';

const HotelsContext = createContext({});

const HotelsProvider = (props) => {
    const { id, widgetType, isAutocompleteVisible, setWidgetConfig } = props;

    const providerValue = useMemo(() => ({ ...props }), [ id ]);

    const { children } = props;

    useEffect(() => {
        if (widgetType === 'searchbar' || widgetType === 'hotels') {
            const { autocompleteFilterEnabled, isConnected, id: widgetId } = getInlineConfigFromQueue(widgetType);

            if (autocompleteFilterEnabled === undefined && !isConnected) {
                setWidgetConfig(widgetId, widgetType, { autocompleteFilterEnabled: isAutocompleteVisible });
            }
        }
    }, []);

    return (
        <HotelsContext.Provider value={providerValue}>
            {children}
        </HotelsContext.Provider>
    );
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const onFilterProperties = async (value, type) => {
        dispatch(propertiesActions.resetPropertiesByGeoPosition());

        if (type === 'city' || type === 'state') {
            await dispatch(propertiesActions.changePropertiesByLocation(value));
        } else if (type === 'google_places') {
            await dispatch(propertiesActions.changePropertiesByGeoPosition(value));
        } else if (type === 'GEO_REGION') {
            await dispatch(propertiesActions.changePropertiesByGeoName(value));
        } else if (type === 'hotel') {
            await dispatch(propertiesActions.changePropertiesByCode(value));
        } else if (type === 'country') {
            await dispatch(propertiesActions.changePropertiesByCountryCode(value));
        } else if (type === 'classification') {
            await dispatch(propertiesActions.changePropertiesByClassification(value));
        }

        scrollToTop(10, 40);
        dispatch(propertiesActions.resetPagination());
        await dispatch(propertiesActions.getHotelsList());
    };

    const setAutocompleteFilter = async (item) => {
        dispatch(propertiesActions.setAutocompleteFilter(item, ownProps.id, ownProps.widgetType));
    };

    const resetAutocompleteFilters = async () => {
        dispatch(propertiesActions.cleanAutocompleteFilters(ownProps.id));
        dispatch(propertiesActions.resetPagination());
        dispatch(propertiesActions.getHotelsList());
    };

    const onChangeSearchInput = (valueSearchInput) => {
        dispatch(propertiesActions.changePropertyNameFilterTemp(valueSearchInput));
        return dispatch(propertiesActions.getSuggestions(valueSearchInput));
    };

    const loadClassifications = (language, channelId) => {
        dispatch(propertiesActions.setClassifications(language, channelId, ownProps.id));
    };

    const handleOnGetPlace = async (geoRegionId, type) => {
        const locations = await dispatch(propertiesActions.getGooglePlaces(geoRegionId, type?.toUpperCase()));
        return locations;
    };

    const setWidgetConfig = (id, widgetType, config) => {
        dispatch(setConfig(id, widgetType, config));
    };

    return {
        onFilterProperties,
        setAutocompleteFilter,
        resetAutocompleteFilters,
        onChangeSearchInput,
        loadClassifications,
        handleOnGetPlace,
        setWidgetConfig,
    };
};

const mapStateToProps = state => ({
    isAutocompleteVisible: state.settings.data.autocomplete?.visible || false,
});

export default connect(mapStateToProps, mapDispatchToProps)(HotelsProvider);

const useHotel = () => {
    const context = useContext(HotelsContext);
    if (context === undefined) {
        throw new Error('useHotel can only be used inside HotelsProvider');
    }
    return context;
};

export {
    HotelsContext,
    useHotel,
};

HotelsProvider.propTypes = {
    children              : PropTypes.node.isRequired,
    id                    : PropTypes.string.isRequired,
    widgetType            : PropTypes.string.isRequired,
    isAutocompleteVisible : PropTypes.bool.isRequired,
    setWidgetConfig       : PropTypes.func.isRequired,
};
